import { MerchantDashboardStatModel } from '@/features/dashboardMerchant/model'
import { AmountInfo } from '@/features/dashboardMerchant/ui'
import { BalanceChangeBadge } from '@/shared/components'
import { getPercentChange } from '@/shared/components/BalanceChangeBadge/lib'
import {
  InfoCard,
  InformationStatisticCards,
} from '@/shared/components/InformationStatisticCards/InformationStatisticCards'
import { formatTimeFromSeconds } from '@/shared/lib'
import { StatisticTabNames } from '@/shared/lib/models/tabsStatisticOptions'

type PanelProps = {
  data: MerchantDashboardStatModel | undefined
  type: StatisticTabNames
}

export const StatisticMerchantPanel = ({ data, type }: PanelProps) => {
  const currentData = type === 'payIn' ? data?.topup : data?.withdraw

  const isPayIn = type === 'payIn'

  const infoCards: InfoCard[] = currentData
    ? [
        {
          id: 1,
          key: isPayIn ? 'Входящие сделки' : 'Исходящие заявки',
          value: currentData.paidCount,
        },
        // {
        //   id: 2,
        //   key: 'Прибыль',
        //   value: 0,
        // },
        // {
        //   id: 3,
        //   key: 'Активные реквизиты',
        //   value: 0,
        // },
        {
          id: 4,
          key: 'Конверсия',
          value:
            currentData.totalCount > 0 && currentData.paidCount > 0
              ? `${((currentData.paidCount / currentData.totalCount) * 100).toFixed(1)}%`
              : '0%',
        },
        {
          id: 5,
          key: 'Среднее время обработки ордера',
          value: formatTimeFromSeconds(currentData.paidAverageConfirmSeconds ?? 0),
        },
      ]
    : [
        { id: 1, key: isPayIn ? 'Входящие сделки' : 'Исходящие заявки', value: '0' },
        // { id: 2, key: 'Прибыль', value: '0 USDT' },
        // { id: 3, key: 'Активные реквизиты', value: '0 USDT' },
        { id: 4, key: 'Конверсия', value: '0%' },
        { id: 5, key: 'Среднее время обработки ордера', value: '0 мин.' },
      ]

  const currentBalance = isPayIn ? currentData?.paidAmountTo : currentData?.paidAmountFrom

  console.log({ currentBalance })

  const percentChange = data?.yesterdayTopup
    ? getPercentChange(data?.yesterdayTopup.paidAmountFrom ?? 0, currentData?.paidAmountFrom ?? 0)
    : 0

  return (
    <div>
      <div className="flex gap-[10px] mb-4">
        {typeof percentChange === 'number' &&
          percentChange !== 0 &&
          isPayIn &&
          data?.yesterdayTopup && (
            <BalanceChangeBadge
              currentBalance={currentData?.paidAmountFrom ?? 0}
              yesterdayBalance={data?.yesterdayTopup.paidAmountFrom ?? 0}
            />
          )}
      </div>

      <AmountInfo paidAmountSum={currentBalance ?? 0} className="mb-[40px]" type={type} />

      <InformationStatisticCards infoCards={infoCards} />
    </div>
  )
}
